import axios from "axios"
import { putCheck } from "./checkSlice";


export function checkPutAxios(checkData) {
        return async function checkPutThunk(dispatch, getState) {
            const response = await axios.put(`/api/check`, checkData)
            dispatch(putCheck(response.data))
        };
    }